import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { MathVaultProductAPIStat } from '~/redux/apis/user-stats-api'

import ProductCardContainer from '../ProductCardContainer'

import MathVaultSummary from './MathVaultSummary'
import MathVaultDetails from './MathVaultDetails'

interface MathVaultProps {
  product: MathVaultProductAPIStat
}

export default function MathVaultProductCard({ product }: MathVaultProps): React.ReactElement {
  const { t } = useTranslation('statistics')
  const [showContent, setShowContent] = useState(false)

  const cardName = `${t('math-vault')} - ${product.room}`

  const onToggle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <MathVaultSummary cardData={product} onClick={onToggle} showContent={showContent} />
      {showContent && <MathVaultDetails product={product} />}
    </ProductCardContainer>
  )
}
